import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import BooksMenu from '../BooksMenu';
import css from './BooksSelectedMenu.module.scss';
import { RSButton } from 'src/reservation-page/RSButton';

interface OwnProps {
  changeTarget: () => void;
  changeOption?: () => void;
}

interface Renderable {
  name: string;
  duration?: number; // second
  price?: string;
  options: Array<{
    name: string;
    price: string | null;
  }>;
}

type Props = OwnProps & Renderable;

const BooksSelectedMenu = ({
  options,
  changeTarget,
  changeOption,
  ...props
}: Props) => {
  const classes = classNames(css.BooksSelectedMenu);
  const intl = useIntl();

  return (
    <div className={classes}>
      <div className={css.BooksSelectedMenu__Item}>
        <BooksMenu
          className={css.BooksSelectedMenu__Menu}
          menuName={props.name}
          duration={props.duration}
          price={props.price}
        />
        <div className="ml-8">
          <RSButton variant="outline" onClick={changeTarget}>
            {intl.formatMessage({ id: 'books.button.change' })}
          </RSButton>
        </div>
      </div>
      {options.length > 0 && (
        <div className={css.BooksSelectedMenu__Item}>
          <ul className={css.BooksSelectedMenu__Options}>
            {options.map((option, index) => (
              <li key={index} className={css.BooksSelectedMenu__OptionsItem}>
                <span className={css.BooksSelectedMenu__OptionsName}>
                  {option.name}
                </span>
                <span className={css.BooksSelectedMenu__OptionsPrice}>
                  {option.price && (
                    <FormattedMessage
                      id="books.optionsList.price"
                      values={{ price: option.price }}
                    />
                  )}
                </span>
              </li>
            ))}
          </ul>
          <div className="ml-8">
            <RSButton variant="outline" onClick={changeOption}>
              {intl.formatMessage({ id: 'books.button.change' })}
            </RSButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default BooksSelectedMenu;
